const dateCircleSize = 44;
export { dateCircleSize };
